import React from "react";
import moment from "moment";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

import Mask from "@/react-components/Mask";
import ConfirmUpdateAgreement from "@/react-components/ConfirmUpdateAgreement";
// 課金-ADD-START
import ConfirmUpdatePaymentAgreement from "@/react-components/ConfirmUpdatePaymentAgreement";
// 課金-ADD-END
import ConfirmUpdatePolicy from "@/react-components/ConfirmUpdatePolicy";
import ConfirmUpdateInquiry from "@/react-components/ConfirmUpdateInquiry";
import { agreementStatusEnum } from "@/utils/enum";
import { api } from "@/utils/api";
import { setToken } from "@/utils/cookies";
import { updateAuthentication as updateAuthenticationDispatch } from "@/models/user";

class ConfirmUpdateMask extends React.Component {
  constructor(props) {
    super(props);

    this.state = { status: agreementStatusEnum.notUpdate };
    this.init();
  }

  componentDidUpdate(prevProps) {
    if (prevProps?.location?.pathname !== this.props?.location?.pathname) {
      this.checkTime();
    }
  }

  init = () => {
    this.maskRef = React.createRef();
    this.checkTime();
  };

  checkTime = async () => {
    try {
      const { authentication, updateAuthentication } = this.props;
      const time = await api.common.getTime();
      if (
        !authentication?.lastShowAgreementTime ||
        moment(time).format("YYYYMMDD") >
          moment(authentication?.lastShowAgreementTime).format("YYYYMMDD")
      ) {
        this.showAgreement = true;
        const newAuthentication = {
          ...authentication,
          lastShowAgreementTime: time,
        };
        setToken(newAuthentication);
        updateAuthentication({ authentication: newAuthentication });
        this.setState({ status: agreementStatusEnum.notUpdate });
      }
    } catch (error) {
      console.error("error = " + error);
    }
  };

  updateStatus = (status, isFuture) => {
    // 課金-UPD-START
    switch (status) {
      case agreementStatusEnum.agreementWillUpdate:
      case agreementStatusEnum.paymentAgreementWillUpdate:
      case agreementStatusEnum.policyWillUpdate:
      case agreementStatusEnum.inquiryWillUpdate:
        if (this.showAgreement || !isFuture) {
          this.maskRef.current.show();
        } else if (status === agreementStatusEnum.agreementWillUpdate) {
          status = agreementStatusEnum.agreementUpdated;
        } else if (status === agreementStatusEnum.paymentAgreementWillUpdate) {
          status = agreementStatusEnum.paymentAgreementUpdated;
        } else if (status === agreementStatusEnum.policyWillUpdate) {
          status = agreementStatusEnum.policyUpdated;
        } else if (status === agreementStatusEnum.inquiryWillUpdate) {
          status = agreementStatusEnum.inquiryUpdated;
        }
        break;
      case agreementStatusEnum.agreementUpdated:
      case agreementStatusEnum.paymentAgreementUpdated:
      case agreementStatusEnum.policyUpdated:
      case agreementStatusEnum.inquiryUpdated:
        this.maskRef.current.hide();
        break;

      default:
        break;
    }
    this.setState({ status });
    // 課金-UPD-END
  };

  render() {
    const { status } = this.state;

    return (
      <Mask ref={this.maskRef}>
        {status < agreementStatusEnum.agreementUpdated ? (
          <ConfirmUpdateAgreement updateStatus={this.updateStatus} />
        ) : // 課金-ADD-START
        status < agreementStatusEnum.paymentAgreementUpdated ? (
          <ConfirmUpdatePaymentAgreement updateStatus={this.updateStatus} />
        ) : // 課金-ADD-END
        status < agreementStatusEnum.policyUpdated ? (
          <ConfirmUpdatePolicy updateStatus={this.updateStatus} />
        ) : (
          <ConfirmUpdateInquiry updateStatus={this.updateStatus} />
        )}
      </Mask>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    authentication: state?.user?.authentication,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateAuthentication: (action) =>
      dispatch(updateAuthenticationDispatch(action)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ConfirmUpdateMask));
